// Get Product Images by color and variant ID, inject them in the right place in the product item & product page
// Take in a product object, return an object with the variant id as the key and an array of images as the value.           

// Variant ID Featured Images
export function getFeaturedImagesById(product) {
    let variants = product.variants
    let images = product.images
  
    let featured_images = []
  
    for (let variant of variants) {
      if (variant.featured_image) {

        let obj = {
          src: variant.featured_image.src,
          variant_id: variant.id
        }
        featured_images.push(obj)
      } else if (variant.image_id) {

        // ...shopify is annoying

        let image = images.find(e => (e.id) === variant.image_id)

        let obj = {
          src: image.src,
          variant_id: variant.id
        }
        featured_images.push(obj)
      }
    }
  
    // if same image is used for multiple variants, throw an error
    let featured_images_unique = new Set(featured_images.map(item => item.src))
  
  
    if (featured_images.length == 0) {
      return [];
    }
  
    // if (featured_images.length != [...featured_images_unique].length) {
    //   console.log('You have one image set as the featured image for two variants, please set a different image as the featured image for each variant.')
    //   return;
    // }
  
    let new_images = {}
    let variant_id = ''
  
    for (let image of images) {
      for (let featured_image of featured_images) {
            
            let featured_image_without_https = featured_image['src'].replace('https:', '')
          
            if (typeof image === 'object') {
                image = image['src'].replace('https:', '')
            }

            if (featured_image_without_https == image) {
                variant_id = featured_image.variant_id
            }
      }
  
      if (new_images[variant_id] == undefined) {
        new_images[variant_id] = []
      }
      new_images[variant_id].push(image)
    }

  
    return new_images;
}

// Color Featured Images
export function getFeaturedImagesByColor(product) {
  let variants = product.variants
  let images = product.images

  let featured_images = []

  for (let variant of variants) {
    if (variant.featured_image) {

      let obj = {
        src: variant.featured_image.src,
        variant_id: variant.id,
        color: variant.option1
      }
      featured_images.push(obj)
    } else if (variant.image_id) {

      // ...shopify is annoying

      let image = images.find(e => (e.id) === variant.image_id)

      let obj = {
        src: image.src,
        variant_id: variant.id,
        color: variant.option1
      }
      featured_images.push(obj)
    }
  }

  // console.log('images', images);
  // console.log('featured_images', featured_images);

  // if same image is used for multiple variants, throw an error
  let featured_images_unique = new Set(featured_images.map(item => item.src))


  if (featured_images.length == 0) {
    return [];
  }

  // if (featured_images.length != [...featured_images_unique].length) {
  //   console.log('You have one image set as the featured image for two variants, please set a different image as the featured image for each variant.')
  //   return;
  // }

  let new_images = {}
  let variant_id = ''

  for (let image of images) {
    for (let featured_image of featured_images) {
          
      let featured_image_without_https = featured_image['src'].replace('https:', '')
    
      if (typeof image === 'object') {
          image = image['src'].replace('https:', '')
      }

      if (featured_image_without_https == image) {
          variant_id = featured_image.color
      }
    }

    if (new_images[variant_id] == undefined) {
      new_images[variant_id] = []
    }
    new_images[variant_id].push(image)
  }

  // console.log('new_images', new_images);

  return new_images;
}

// Color Product Images
export function getImagesByColor(product, color_index) {
  let variants = product.variants
  let images = product.images

  let featured_images = []

  if (color_index === undefined) {
    color_index = 'option1';
  }

  for (let variant of variants) {
    if (variant.featured_image) {

      let obj = {
        src: variant.featured_image.src,
        variant_id: variant.id,
        color: variant[color_index]
      }
      featured_images.push(obj)
    } else if (variant.featured_media) {

      // ...shopify is annoying

      // let image = images.find(e => (e.id) === variant.image_id)
      let image = images.find(e => (e) === variant.featured_media.preview_image.src);

      let obj = {
        src: image.src,
        variant_id: variant.id,
        color: variant[color_index]
      }
      featured_images.push(obj)
    }
  }

  // if same image is used for multiple variants, throw an error
  let featured_images_unique = new Set(featured_images.map(item => item.src))


  if (featured_images.length == 0) {
    return [];
  }

  // if (featured_images.length != [...featured_images_unique].length) {
  //   console.log('You have one image set as the featured image for two variants, please set a different image as the featured image for each variant.')
  //   return;
  // }

  let new_images = {}
  let variant_id = ''

  for (let image of images) {
    for (let featured_image of featured_images) {
          
      let featured_image_without_https = featured_image['src'].replace('https:', '')
      let image_without_https = image.replace('https:', '');
      // if (typeof image === 'object') {
      //   image = image['src'].replace('https:', '')
      // }

      if (featured_image_without_https == image_without_https) {
        variant_id = featured_image.color
      }
    }

    if (new_images[variant_id] == undefined) {
      new_images[variant_id] = []
    }
    new_images[variant_id].push(image)
  }

  return new_images;
}

// Product Images
export function getImages(product) {

  let images = []

  for (let image of product.images) {
    images.push(image.src)
  }

  return images
}